import React, { Component } from 'react';
//import isEqual from 'lodash.isequal';
import Autosuggest from 'react-autosuggest';
import UtilFunctions from './../UtilFunctions';
import serviceauth from '../auth/serviceauth';

class Autosuggestions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      suggestions: [],
      highlightedIndex: null,
    };
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    this.onSuggestionHighlighted = this.onSuggestionHighlighted.bind(this);
    this.containerRef = React.createRef();
  }

  suggestions = null;

  componentDidMount() {
    // Add aria-labelledby to the combobox container that react-autosuggest creates
    if (this.containerRef.current) {
      const combobox = this.containerRef.current.querySelector('[role="combobox"]');
      if (combobox && this.props['aria-labelledby']) {
        combobox.setAttribute('aria-labelledby', this.props['aria-labelledby']);
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.term !== this.props.term &&
      this.props.term !== undefined &&
      this.props.term !== ''
    ) {
      fetch(
        serviceauth.getRequestObject(
          UtilFunctions.getSubjectSimpleListUrl(this.props.term),
          'GET'
        )
      )
        .then((response) => {
          if (response.status === 401) {
            serviceauth.reauth();
          }
          return response.json();
        })
        .then((subjects) => {
          // console.log(subjects)
          this.suggestions = subjects;
        });
    }
    if (prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value,
      });
    }
  }

  //calculate suggestions for any given input value.
  getSuggestions = (value) => {
    const inputValue = value.trim().toUpperCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : this.suggestions.filter(
          (s) => s.CODE.toUpperCase().indexOf(inputValue) >= 0
        );
  };

  // When suggestion is clicked, Autosuggest needs to populate the input
  getSuggestionValue = (suggestion) =>
    suggestion.SUBJECT.toUpperCase().split(':')[0];

  onChange = (event, { newValue }) => {
    this.setState(
      {
        value: newValue.toUpperCase(),
      },
      () => {
        let event2 = {
          target: {
            type: 'input',
            name: this.props.name,
            value: newValue,
          },
        };
        this.props.onChange(event2);
      }
    );
  };

  // Autosuggest will call this function every time you need to update suggestions.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  //Used so that the search is not activated when hitting enter on one of the suggestions.
  suggestionSelected = false;
  onSuggestionSelected(event) {
    if (event.keyCode === 13) this.suggestionSelected = true;
  }

  onSuggestionHighlighted({ suggestion }) {
    this.setState({
      highlightedIndex: suggestion ? suggestion : null,
    });
  }

  onKeyDown(event) {
    // Don't trigger parent's onKeyDown for arrow keys or Enter when suggestions are open
    const isArrowKey = event.keyCode === 38 || event.keyCode === 40; // Up or Down arrow
    const isEnterKey = event.keyCode === 13;
    const hasSuggestions = this.state.suggestions.length > 0;

    // If arrow keys are pressed and suggestions are visible, don't trigger parent handler
    if (isArrowKey && hasSuggestions) {
      return;
    }

    // If Enter is pressed and a suggestion was selected, don't trigger parent handler
    if (isEnterKey && this.suggestionSelected) {
      this.suggestionSelected = false;
      return;
    }

    // For all other cases, trigger the parent's onKeyDown (e.g., Enter to search)
    if (!this.suggestionSelected) {
      this.props.onKeyDown(event);
    }

    this.suggestionSelected = false;
  }

  render() {
    const { value, suggestions, highlightedIndex } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder,
      value,
      onChange: this.onChange,
      name: this.props.name,
      onKeyDown: this.onKeyDown,
      className: 'form-control asu upper',
      id: this.props.id,
      'aria-autocomplete': 'list',
      title: this.props.placeholder || 'Subject', // Fallback for accessibility tools
    };

    // Add aria-describedby if provided in props
    if (this.props['aria-describedby']) {
      inputProps['aria-describedby'] = this.props['aria-describedby'];
    }

    // Add aria-labelledby if provided in props
    if (this.props['aria-labelledby']) {
      inputProps['aria-labelledby'] = this.props['aria-labelledby'];
    }

    // Get announcement text for screen readers
    const announcement = highlightedIndex
      ? `${highlightedIndex.CODE} ${highlightedIndex.DESCR}`
      : suggestions.length > 0
      ? `${suggestions.length} suggestions available`
      : '';

    return (
      <div ref={this.containerRef}>
        <Autosuggest
          id={this.props.id + '-autosuggest'}
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          onSuggestionHighlighted={this.onSuggestionHighlighted}
          getSuggestionValue={this.getSuggestionValue}
          inputProps={inputProps}
          onSuggestionSelected={this.onSuggestionSelected}
          renderSuggestion={(suggestion) => (
            <div>
              <strong>{suggestion.CODE} </strong>
              {suggestion.DESCR}
            </div>
          )}
          renderSuggestionsContainer={({ containerProps, children }) => {
            const { ref, ...restContainerProps } = containerProps;
            return (
              <div 
                ref={ref} 
                {...restContainerProps}
                aria-hidden="true"
                role="presentation"
              >
                {children}
              </div>
            );
          }}
        />
        {/* Live region for screen reader announcements */}
        <div
          role="status"
          aria-live="polite"
          aria-atomic="true"
          className="visually-hidden"
        >
          {announcement}
        </div>
      </div>
    );
  }
}

// const languages = [
//     {
//       name: 'C',
//       year: 1972
//     },
//     {
//       name: 'Elm',
//       year: 2012
//     },
//   ];

export default Autosuggestions;
